<app-splash-screen></app-splash-screen>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

  <ngx-ui-loader></ngx-ui-loader><div ngxUiLoaderBlurred><router-outlet></router-outlet></div>